export default __webpack_public_path__ + "static/media/dvameka-nerfthis.7232d735.mp3";